import React, { useEffect, useState } from "react";
import Sidebar from "../../components/common/Sidebar";
import Header from "../../components/common/Header";
import hospitalIcon from "../../asessts/Images/hospital_icon.svg";
import client from "../../services/Client";
import PulseLoader from "../../components/loader/Loading";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartWithDetails from "../../components/ChartWithDetails";

ChartJS.register(ArcElement, Tooltip, Legend);

function Dashboard() {
  const [counts, setCounts] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await client.get(`/admin/profile/total-counts`);
      if (response.data.status) {
        setCounts(response.data.data);
      } else {
        setError("Failed to load data");
      }
    } catch (error) {
      console.error("Error while fetching data", error);
      setError("Error loading dashboard data");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className="admin-dashboard">
        <Sidebar />
        <div className="main-dashboard subadmin-dashboard">
          <Header title={"Dashboard"} />
          <div className="dashboard-loading">
            <PulseLoader color="#2E5BFF" size={15} />
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-dashboard">
        <Sidebar />
        <div className="main-dashboard subadmin-dashboard">
          <Header title={"Dashboard"} />
          <div className="dashboard-error">
            <p>{error}</p>
            <button onClick={fetchData}>Retry</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-dashboard">
      <Sidebar />
      <div className="main-dashboard subadmin-dashboard">
        <Header title={"Dashboard"} />
        <div className="dashboard-main">
          <div className="dashboard-left">
            <div className="dashboard-main-details">
              <div className="dashboard-details-left">
                <div className="head">
                  <h4>Facilities</h4>
                </div>
                <div className="dashboard-main-col">
                  <div className="dashboard-details-col">
                    <div className="dashboard-details-heading p-spacing">
                      <div className="main-heading">
                        <span>Hospitals</span>
                        <h3>{counts.healthFacilitities.hospitalCount}</h3>
                      </div>
                      <div className="details-img">
                        <span>
                          <img src={hospitalIcon} alt="" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="dashboard-details-col">
                    <div className="dashboard-details-heading">
                      <div className="main-heading">
                        <span>Pharmacies</span>
                        <h3>{counts.healthFacilitities.pharmacyCount}</h3>
                      </div>
                      <div className="details-img">
                        <span>
                          <img src={hospitalIcon} alt="" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="dashboard-details-col">
                    <div className="dashboard-details-heading p-spacing">
                      <div className="main-heading">
                        <span>Laboratories</span>
                        <h3>{counts.healthFacilitities.laboratoryCount}</h3>
                      </div>
                      <div className="details-img">
                        <span>
                          <img src={hospitalIcon} alt="" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="dashboard-details-col">
                    <div className="dashboard-details-heading">
                      <div className="main-heading">
                        <span>Fitness Centre</span>
                        <h3>{counts.healthFacilitities.fitnessCenterCount}</h3>
                      </div>
                      <div className="details-img">
                        <span>
                          <img src={hospitalIcon} alt="" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="dashboard-details-right">
                <div className="graph">
                  <div className="graph-head">
                    <h4>Facilities</h4>
                  </div>
                  <div className="graph-container">
                    <ChartWithDetails
                      title="Facilities"
                      labels={[
                        "Hospitals",
                        "Pharmacies",
                        "Laboratories",
                        "Fitness Centres",
                      ]}
                      values={[
                        counts.healthFacilitities.hospitalCount,
                        counts.healthFacilitities.pharmacyCount,
                        counts.healthFacilitities.laboratoryCount,
                        counts.healthFacilitities.fitnessCenterCount,
                      ]}
                      colors={["#36A2EB", "#4BC0C0", "#FFCE56", "#FF6384"]}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="dashboard-main-details">
              <div className="dashboard-details-left">
                <div className="head">
                  <h4>Health Professionals</h4>
                </div>
                <div className="dashboard-main-col">
                  <div className="dashboard-details-col">
                    <div className="dashboard-details-heading p-spacing">
                      <div className="main-heading">
                        <span>Doctors</span>
                        <h3>{counts.healthProfessionals.doctorCount}</h3>
                      </div>
                      <div className="details-img">
                        <span>
                          <img src={hospitalIcon} alt="" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="dashboard-details-col">
                    <div className="dashboard-details-heading">
                      <div className="main-heading">
                        <span>Nurses</span>
                        <h3>{counts.healthProfessionals.nurseCount}</h3>
                      </div>
                      <div className="details-img">
                        <span>
                          <img src={hospitalIcon} alt="" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="dashboard-details-col">
                    <div className="dashboard-details-heading p-spacing">
                      <div className="main-heading">
                        <span>Physiotherapists</span>
                        <h3>
                          {counts.healthProfessionals.physiotherapistCount}
                        </h3>
                      </div>
                      <div className="details-img">
                        <span>
                          <img src={hospitalIcon} alt="" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="dashboard-details-col">
                    <div className="dashboard-details-heading">
                      <div className="main-heading">
                        <span>Lab Scientists</span>
                        <h3>
                          {counts.healthProfessionals.medicalLabScientistCount}
                        </h3>
                      </div>
                      <div className="details-img">
                        <span>
                          <img src={hospitalIcon} alt="" />
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="dashboard-details-right">
                <div className="graph">
                  <div className="graph-head">
                    <h4>Health Professionals</h4>
                  </div>
                  <div className="graph-container">
                    <ChartWithDetails
                      title="Health Professionals"
                      labels={[
                        "Doctors",
                        "Nurses",
                        "Physiotherapists",
                        "Lab Scientists",
                      ]}
                      values={[
                        counts.healthProfessionals.doctorCount,
                        counts.healthProfessionals.nurseCount,
                        counts.healthProfessionals.physiotherapistCount,
                        counts.healthProfessionals.medicalLabScientistCount,
                      ]}
                      colors={["#36A2EB", "#FF6384", "#4BC0C0", "#9966FF"]}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
